var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPluralsightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 24C38 31.7323 31.7317 38 23.9997 38C16.2675 38 10 31.7323 10 24C10 16.2677 16.2675 10 23.9997 10C31.7317 10 38 16.2677 38 24Z",
    fill: "url(#paint0_linear_202_105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4006 16.7242V31.2743L33.0014 23.9997L20.4006 16.7242ZM21.6069 18.8136L30.5888 23.9997L21.6069 29.1856V18.8136Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5042 18.3127V29.6859L27.3529 23.9989L17.5042 18.3127ZM18.7104 20.4021L24.9411 23.9989L18.7104 27.5971V20.4021Z",
    fill: "#FFFFFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_202_105",
    x1: 1409.97,
    y1: 54.128,
    x2: 1409.97,
    y2: 2822.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7197E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPluralsightIcon);
export default __webpack_public_path__ + "static/media/logo_pluralsight-icon.a7d96aedc6b9bcbba9be13469aaef8c4.svg";
export { ForwardRef as ReactComponent };